import React from 'react'
import Select from '@/components/Select'
import { RoleInfo, PermissionInfo } from '@/types'
import { Column, ColumnAction } from '@/components/Table'
import { ConfirmButton } from '@/components/Button'

export const roleColumns: (
  callback: (action: ColumnAction, data: RoleInfo) => () => void
) => Column<RoleInfo & { action?: unknown }>[] = (callback) => [
  {
    id: 'name',
    label: '角色名',
    width: 200,
  },
  {
    id: 'perms',
    label: '权限',
    // @ts-ignore
    format: ({
      row,
      value,
    }: {
      row: RoleInfo;
      value: Pick<PermissionInfo, 'id' | 'name'>[];
    }) => {
      return (
        <Select
          sx={{ width: '100%' }}
          onFocus={callback('edit', row)}
          multiple={true}
          value={value?.map((item) => item?.id) ?? []}
          options={
            value?.map((item) => ({ label: item.name, value: item.id })) ?? []
          }
        />
      )
    },
  },
  {
    id: 'action',
    label: '操作',
    width: 120,
    format: ({ row }: { row: RoleInfo; value: unknown }) => {
      return (
        <ConfirmButton
          danger='true'
          onClick={callback('delete', row)}
          disabled={row?.type === 'builtin'}
        >
          删除
        </ConfirmButton>
      )
    },
  },
]
